import * as React from 'react'
import { GatsbyBrowser } from 'gatsby'
import { Layout } from './src/components/layouts'
import './src/styles/global.css'
import { RecoilRoot } from 'recoil'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  return (
    <RecoilRoot>
      <Layout>
        {element}
      </Layout>
    </RecoilRoot>
  )
}